// extracted by mini-css-extract-plugin
module.exports = {"container":"TooltipError_container__A9OYx","alert-icon":"TooltipError_alert-icon__sEYMh","error-text":"TooltipError_error-text__OgpOe","root":"TooltipError_root__BAjX2"};